import { atom } from 'jotai';

import {
  CycleCountTaskSortOption,
  cycleCountTasksQueryAtom,
} from '../_graphql/queryCycleCountTasks';

import { atomFromQueryString } from '~/shared/state';

export const $searchTerm = atomFromQueryString.string('q');
export const $selectedFacility = atomFromQueryString.string('f');
export const $selectedStatus = atomFromQueryString.string('status');
export const $selectedCountType = atomFromQueryString.string('countType');
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);

export const $currentSorting = atom<CycleCountTaskSortOption[]>([
  'TaskNumberDesc',
]);

export const $remoteCycleCountTasks = cycleCountTasksQueryAtom((get) => {
  const selectedFacility = get($selectedFacility);
  const selectedStatus = get($selectedStatus);
  const _selectedCountType = get($selectedCountType);
  const limit = get($limit);
  const offset = get($offset);
  const sorting = get($currentSorting);

  const params: {
    status?: string;
    countType?: string;
    facilityIds?: string[];
    limit: number;
    offset: number;
    sorting: CycleCountTaskSortOption[];
  } = {
    limit,
    offset,
    sorting,
  };

  if (selectedFacility && selectedFacility !== 'all') {
    params.facilityIds = [selectedFacility];
  }
  if (selectedStatus && selectedStatus !== 'all') {
    params.status = selectedStatus;
  }

  return {
    variables: params,
  };
});
